// This file is auto-generated from tmp/*.json files

export const chartData = {
  "series": [
    {
      "currency": "USD",
      "exchange": "NASDAQ",
      "id": "TSLA",
      "intervalSec": 1800,
      "name": "Tesla Inc",
      "points": [
        {
          "changeAbs": 0.0,
          "changePct": 0.0,
          "price": 400.9,
          "tsLocal": "2026-02-06T09:30",
          "tsUtcMs": 1770388200000,
          "tzOffsetSec": -18000,
          "volume": 478695
        },
        {
          "changeAbs": 5.8799999999999955,
          "changePct": 0.014666999251683702,
          "price": 406.78,
          "tsLocal": "2026-02-06T10:00",
          "tsUtcMs": 1770390000000,
          "tzOffsetSec": -18000,
          "volume": 8018512
        },
        {
          "changeAbs": 9.210000000000036,
          "changePct": 0.02297331005238223,
          "price": 410.11,
          "tsLocal": "2026-02-06T10:30",
          "tsUtcMs": 1770391800000,
          "tzOffsetSec": -18000,
          "volume": 5395521
        },
        {
          "changeAbs": 8.16500000000002,
          "changePct": 0.020366674981292146,
          "price": 409.065,
          "tsLocal": "2026-02-06T11:00",
          "tsUtcMs": 1770393600000,
          "tzOffsetSec": -18000,
          "volume": 4777532
        },
        {
          "changeAbs": 9.370000000000005,
          "changePct": 0.02337241207283613,
          "price": 410.27,
          "tsLocal": "2026-02-06T11:30",
          "tsUtcMs": 1770395400000,
          "tzOffsetSec": -18000,
          "volume": 3002707
        },
        {
          "changeAbs": 9.590100000000007,
          "changePct": 0.02392142678972314,
          "price": 410.4901,
          "tsLocal": "2026-02-06T12:00",
          "tsUtcMs": 1770397200000,
          "tzOffsetSec": -18000,
          "volume": 2795260
        },
        {
          "changeAbs": 12.965000000000032,
          "changePct": 0.03233973559491153,
          "price": 413.865,
          "tsLocal": "2026-02-06T12:30",
          "tsUtcMs": 1770399000000,
          "tzOffsetSec": -18000,
          "volume": 2980952
        },
        {
          "changeAbs": 12.450000000000045,
          "changePct": 0.031055125966575323,
          "price": 413.35,
          "tsLocal": "2026-02-06T13:00",
          "tsUtcMs": 1770400800000,
          "tzOffsetSec": -18000,
          "volume": 2532095
        },
        {
          "changeAbs": 11.29000000000002,
          "changePct": 0.028161636318283913,
          "price": 412.19,
          "tsLocal": "2026-02-06T13:30",
          "tsUtcMs": 1770402600000,
          "tzOffsetSec": -18000,
          "volume": 2332670
        },
        {
          "changeAbs": 10.400000000000034,
          "changePct": 0.02594163132950869,
          "price": 411.3,
          "tsLocal": "2026-02-06T14:00",
          "tsUtcMs": 1770404400000,
          "tzOffsetSec": -18000,
          "volume": 1863367
        },
        {
          "changeAbs": 12.455000000000041,
          "changePct": 0.031067597904714497,
          "price": 413.355,
          "tsLocal": "2026-02-06T14:30",
          "tsUtcMs": 1770406200000,
          "tzOffsetSec": -18000,
          "volume": 2404748
        },
        {
          "changeAbs": 12.200000000000045,
          "changePct": 0.03043152905961598,
          "price": 413.1,
          "tsLocal": "2026-02-06T15:00",
          "tsUtcMs": 1770408000000,
          "tzOffsetSec": -18000,
          "volume": 2294903
        },
        {
          "changeAbs": 12.340000000000032,
          "changePct": 0.030780743327513176,
          "price": 413.24,
          "tsLocal": "2026-02-06T15:30",
          "tsUtcMs": 1770409800000,
          "tzOffsetSec": -18000,
          "volume": 2273141
        },
        {
          "changeAbs": 10.210000000000036,
          "changePct": 0.025467697680219597,
          "price": 411.11,
          "tsLocal": "2026-02-06T16:00",
          "tsUtcMs": 1770411600000,
          "tzOffsetSec": -18000,
          "volume": 5916574
        },
        {
          "changeAbs": 9.410000000000025,
          "changePct": 0.023472187577949676,
          "price": 410.31,
          "tsLocal": "2026-02-09T09:30",
          "tsUtcMs": 1770647400000,
          "tzOffsetSec": -18000,
          "volume": 249967
        },
        {
          "changeAbs": 8.620000000000005,
          "changePct": 0.021501621351958107,
          "price": 409.52,
          "tsLocal": "2026-02-09T10:00",
          "tsUtcMs": 1770649200000,
          "tzOffsetSec": -18000,
          "volume": 6779109
        },
        {
          "changeAbs": 12.075000000000045,
          "changePct": 0.03011973060613631,
          "price": 412.975,
          "tsLocal": "2026-02-09T10:30",
          "tsUtcMs": 1770651000000,
          "tzOffsetSec": -18000,
          "volume": 4675515
        },
        {
          "changeAbs": 16.96010000000001,
          "changePct": 0.04230506360688454,
          "price": 417.8601,
          "tsLocal": "2026-02-09T11:00",
          "tsUtcMs": 1770652800000,
          "tzOffsetSec": -18000,
          "volume": 4337319
        },
        {
          "changeAbs": 17.717200000000048,
          "changePct": 0.0441935644799203,
          "price": 418.6172,
          "tsLocal": "2026-02-09T11:30",
          "tsUtcMs": 1770654600000,
          "tzOffsetSec": -18000,
          "volume": 3536538
        },
        {
          "changeAbs": 19.430000000000007,
          "changePct": 0.04846595160888004,
          "price": 420.33,
          "tsLocal": "2026-02-09T12:00",
          "tsUtcMs": 1770656400000,
          "tzOffsetSec": -18000,
          "volume": 3123638
        },
        {
          "changeAbs": 19.650000000000034,
          "changePct": 0.04901471688700433,
          "price": 420.55,
          "tsLocal": "2026-02-09T12:30",
          "tsUtcMs": 1770658200000,
          "tzOffsetSec": -18000,
          "volume": 2548096
        },
        {
          "changeAbs": 18.75,
          "changePct": 0.04676976802195061,
          "price": 419.65,
          "tsLocal": "2026-02-09T13:00",
          "tsUtcMs": 1770660000000,
          "tzOffsetSec": -18000,
          "volume": 1660639
        },
        {
          "changeAbs": 17.375,
          "changePct": 0.043339985033674235,
          "price": 418.275,
          "tsLocal": "2026-02-09T13:30",
          "tsUtcMs": 1770661800000,
          "tzOffsetSec": -18000,
          "volume": 2269122
        },
        {
          "changeAbs": 18.629999999999995,
          "changePct": 0.046470441506610116,
          "price": 419.53,
          "tsLocal": "2026-02-09T14:00",
          "tsUtcMs": 1770663600000,
          "tzOffsetSec": -18000,
          "volume": 1979920
        },
        {
          "changeAbs": 19.275000000000034,
          "changePct": 0.04807932152656531,
          "price": 420.175,
          "tsLocal": "2026-02-09T14:30",
          "tsUtcMs": 1770665400000,
          "tzOffsetSec": -18000,
          "volume": 1809361
        },
        {
          "changeAbs": 18.950000000000045,
          "changePct": 0.0472686455475182,
          "price": 419.85,
          "tsLocal": "2026-02-09T15:00",
          "tsUtcMs": 1770667200000,
          "tzOffsetSec": -18000,
          "volume": 1764459
        },
        {
          "changeAbs": 19.110100000000045,
          "changePct": 0.04766799700673496,
          "price": 420.0101,
          "tsLocal": "2026-02-09T15:30",
          "tsUtcMs": 1770669000000,
          "tzOffsetSec": -18000,
          "volume": 1989111
        },
        {
          "changeAbs": 16.275000000000034,
          "changePct": 0.040596158643053215,
          "price": 417.175,
          "tsLocal": "2026-02-09T16:00",
          "tsUtcMs": 1770670800000,
          "tzOffsetSec": -18000,
          "volume": 3205970
        },
        {
          "changeAbs": 17.355000000000018,
          "changePct": 0.04329009728111753,
          "price": 418.255,
          "tsLocal": "2026-02-10T09:30",
          "tsUtcMs": 1770733800000,
          "tzOffsetSec": -18000,
          "volume": 243718
        },
        {
          "changeAbs": 21.379999999999995,
          "changePct": 0.053330007483162876,
          "price": 422.28,
          "tsLocal": "2026-02-10T10:00",
          "tsUtcMs": 1770735600000,
          "tzOffsetSec": -18000,
          "volume": 6934993
        },
        {
          "changeAbs": 22.340000000000032,
          "changePct": 0.05572461960588684,
          "price": 423.24,
          "tsLocal": "2026-02-10T10:30",
          "tsUtcMs": 1770737400000,
          "tzOffsetSec": -18000,
          "volume": 4603227
        },
        {
          "changeAbs": 24.15500000000003,
          "changePct": 0.06025193315041165,
          "price": 425.055,
          "tsLocal": "2026-02-10T11:00",
          "tsUtcMs": 1770739200000,
          "tzOffsetSec": -18000,
          "volume": 4175883
        },
        {
          "changeAbs": 20.730000000000018,
          "changePct": 0.05170865552506864,
          "price": 421.63,
          "tsLocal": "2026-02-10T11:30",
          "tsUtcMs": 1770741000000,
          "tzOffsetSec": -18000,
          "volume": 3132199
        },
        {
          "changeAbs": 22.804100000000005,
          "changePct": 0.05688226490396609,
          "price": 423.7041,
          "tsLocal": "2026-02-10T12:00",
          "tsUtcMs": 1770742800000,
          "tzOffsetSec": -18000,
          "volume": 3125992
        },
        {
          "changeAbs": 23.985000000000014,
          "changePct": 0.05982788725367926,
          "price": 424.885,
          "tsLocal": "2026-02-10T12:30",
          "tsUtcMs": 1770744600000,
          "tzOffsetSec": -18000,
          "volume": 3523986
        },
        {
          "changeAbs": 24.230000000000018,
          "changePct": 0.06043901222249942,
          "price": 425.13,
          "tsLocal": "2026-02-10T13:00",
          "tsUtcMs": 1770746400000,
          "tzOffsetSec": -18000,
          "volume": 2174745
        },
        {
          "changeAbs": 22.36500000000001,
          "changePct": 0.05578697929658272,
          "price": 423.265,
          "tsLocal": "2026-02-10T13:30",
          "tsUtcMs": 1770748200000,
          "tzOffsetSec": -18000,
          "volume": 2373523
        },
        {
          "changeAbs": 23.689999999999998,
          "changePct": 0.059092042903467194,
          "price": 424.59,
          "tsLocal": "2026-02-10T14:00",
          "tsUtcMs": 1770750000000,
          "tzOffsetSec": -18000,
          "volume": 2206249
        },
        {
          "changeAbs": 24.142899999999997,
          "changePct": 0.06022175106011474,
          "price": 425.0429,
          "tsLocal": "2026-02-10T14:30",
          "tsUtcMs": 1770751800000,
          "tzOffsetSec": -18000,
          "volume": 1788815
        },
        {
          "changeAbs": 24.774200000000008,
          "changePct": 0.061796457969568494,
          "price": 425.6742,
          "tsLocal": "2026-02-10T15:00",
          "tsUtcMs": 1770753600000,
          "tzOffsetSec": -18000,
          "volume": 1901747
        },
        {
          "changeAbs": 23.50120000000004,
          "changePct": 0.05862110251933161,
          "price": 424.4012,
          "tsLocal": "2026-02-10T15:30",
          "tsUtcMs": 1770755400000,
          "tzOffsetSec": -18000,
          "volume": 2289232
        },
        {
          "changeAbs": 24.310000000000002,
          "changePct": 0.06063856323272637,
          "price": 425.21,
          "tsLocal": "2026-02-10T16:00",
          "tsUtcMs": 1770757200000,
          "tzOffsetSec": -18000,
          "volume": 14065283
        },
        {
          "changeAbs": 28.100000000000023,
          "changePct": 0.07009229234223004,
          "price": 429.0,
          "tsLocal": "2026-02-11T09:30",
          "tsUtcMs": 1770820200000,
          "tzOffsetSec": -18000,
          "volume": 16372
        },
        {
          "changeAbs": 30.39500000000004,
          "changePct": 0.07581691194811684,
          "price": 431.295,
          "tsLocal": "2026-02-11T10:00",
          "tsUtcMs": 1770822000000,
          "tzOffsetSec": -18000,
          "volume": 8497064
        },
        {
          "changeAbs": 20.77000000000004,
          "changePct": 0.05180843103018219,
          "price": 421.67,
          "tsLocal": "2026-02-11T10:30",
          "tsUtcMs": 1770823800000,
          "tzOffsetSec": -18000,
          "volume": 7180250
        },
        {
          "changeAbs": 23.257600000000025,
          "changePct": 0.058013469693190385,
          "price": 424.1576,
          "tsLocal": "2026-02-11T11:00",
          "tsUtcMs": 1770825600000,
          "tzOffsetSec": -18000,
          "volume": 5138245
        },
        {
          "changeAbs": 25.295100000000048,
          "changePct": 0.06309578448490907,
          "price": 426.1951,
          "tsLocal": "2026-02-11T11:30",
          "tsUtcMs": 1770827400000,
          "tzOffsetSec": -18000,
          "volume": 3660831
        },
        {
          "changeAbs": 22.340000000000032,
          "changePct": 0.05572461960588684,
          "price": 423.24,
          "tsLocal": "2026-02-11T12:00",
          "tsUtcMs": 1770829200000,
          "tzOffsetSec": -18000,
          "volume": 3039773
        },
        {
          "changeAbs": 23.873800000000017,
          "changePct": 0.05955051134946375,
          "price": 424.7738,
          "tsLocal": "2026-02-11T12:30",
          "tsUtcMs": 1770831000000,
          "tzOffsetSec": -18000,
          "volume": 2646625
        },
        {
          "changeAbs": 22.710000000000036,
          "changePct": 0.05664754302818668,
          "price": 423.61,
          "tsLocal": "2026-02-11T13:00",
          "tsUtcMs": 1770832800000,
          "tzOffsetSec": -18000,
          "volume": 2403212
        },
        {
          "changeAbs": 23.835000000000036,
          "changePct": 0.05945372910950371,
          "price": 424.735,
          "tsLocal": "2026-02-11T13:30",
          "tsUtcMs": 1770834600000,
          "tzOffsetSec": -18000,
          "volume": 2081483
        },
        {
          "changeAbs": 24.65990000000005,
          "changePct": 0.06151134946370679,
          "price": 425.5599,
          "tsLocal": "2026-02-11T14:00",
          "tsUtcMs": 1770836400000,
          "tzOffsetSec": -18000,
          "volume": 2120937
        },
        {
          "changeAbs": 26.560000000000002,
          "changePct": 0.06625093539536045,
          "price": 427.46,
          "tsLocal": "2026-02-11T14:30",
          "tsUtcMs": 1770838200000,
          "tzOffsetSec": -18000,
          "volume": 2299171
        },
        {
          "changeAbs": 26.03000000000003,
          "changePct": 0.06492890995260671,
          "price": 426.93,
          "tsLocal": "2026-02-11T15:00",
          "tsUtcMs": 1770840000000,
          "tzOffsetSec": -18000,
          "volume": 1964878
        },
        {
          "changeAbs": 24.82000000000005,
          "changePct": 0.06191070092292355,
          "price": 425.72,
          "tsLocal": "2026-02-11T15:30",
          "tsUtcMs": 1770841800000,
          "tzOffsetSec": -18000,
          "volume": 1705269
        },
        {
          "changeAbs": 27.234100000000012,
          "changePct": 0.06793240209528564,
          "price": 428.1341,
          "tsLocal": "2026-02-11T16:00",
          "tsUtcMs": 1770843600000,
          "tzOffsetSec": -18000,
          "volume": 3774692
        },
        {
          "changeAbs": 29.379999999999995,
          "changePct": 0.0732851085058618,
          "price": 430.28,
          "tsLocal": "2026-02-12T09:30",
          "tsUtcMs": 1770906600000,
          "tzOffsetSec": -18000,
          "volume": 211892
        },
        {
          "changeAbs": 27.475000000000023,
          "changePct": 0.06853330007483169,
          "price": 428.375,
          "tsLocal": "2026-02-12T10:00",
          "tsUtcMs": 1770908400000,
          "tzOffsetSec": -18000,
          "volume": 7772517
        },
        {
          "changeAbs": 28.810000000000002,
          "changePct": 0.07186330755799453,
          "price": 429.71,
          "tsLocal": "2026-02-12T10:30",
          "tsUtcMs": 1770910200000,
          "tzOffsetSec": -18000,
          "volume": 4565900
        },
        {
          "changeAbs": 24.25,
          "changePct": 0.060488899975056125,
          "price": 425.15,
          "tsLocal": "2026-02-12T11:00",
          "tsUtcMs": 1770912000000,
          "tzOffsetSec": -18000,
          "volume": 3655544
        },
        {
          "changeAbs": 18.460000000000036,
          "changePct": 0.04604639560987787,
          "price": 419.36,
          "tsLocal": "2026-02-12T11:30",
          "tsUtcMs": 1770913800000,
          "tzOffsetSec": -18000,
          "volume": 4391252
        },
        {
          "changeAbs": 17.57000000000005,
          "changePct": 0.04382639062110265,
          "price": 418.47,
          "tsLocal": "2026-02-12T12:00",
          "tsUtcMs": 1770915600000,
          "tzOffsetSec": -18000,
          "volume": 4142266
        },
        {
          "changeAbs": 17.120000000000005,
          "changePct": 0.04270391618857572,
          "price": 418.02,
          "tsLocal": "2026-02-12T12:30",
          "tsUtcMs": 1770917400000,
          "tzOffsetSec": -18000,
          "volume": 2864051
        },
        {
          "changeAbs": 13.795000000000016,
          "changePct": 0.0344100773260165,
          "price": 414.695,
          "tsLocal": "2026-02-12T13:00",
          "tsUtcMs": 1770919200000,
          "tzOffsetSec": -18000,
          "volume": 2885504
        },
        {
          "changeAbs": 15.792500000000018,
          "changePct": 0.039392616612621646,
          "price": 416.6925,
          "tsLocal": "2026-02-12T13:30",
          "tsUtcMs": 1770921000000,
          "tzOffsetSec": -18000,
          "volume": 2841387
        },
        {
          "changeAbs": 15.795000000000016,
          "changePct": 0.039398852581691235,
          "price": 416.695,
          "tsLocal": "2026-02-12T14:00",
          "tsUtcMs": 1770922800000,
          "tzOffsetSec": -18000,
          "volume": 2129871
        },
        {
          "changeAbs": 13.890000000000043,
          "changePct": 0.034647044150661124,
          "price": 414.79,
          "tsLocal": "2026-02-12T14:30",
          "tsUtcMs": 1770924600000,
          "tzOffsetSec": -18000,
          "volume": 2203552
        },
        {
          "changeAbs": 14.377499999999998,
          "changePct": 0.035863058119231725,
          "price": 415.2775,
          "tsLocal": "2026-02-12T15:00",
          "tsUtcMs": 1770926400000,
          "tzOffsetSec": -18000,
          "volume": 1986930
        },
        {
          "changeAbs": 13.730000000000018,
          "changePct": 0.034247942130207085,
          "price": 414.63,
          "tsLocal": "2026-02-12T15:30",
          "tsUtcMs": 1770928200000,
          "tzOffsetSec": -18000,
          "volume": 2011060
        },
        {
          "changeAbs": 16.170000000000016,
          "changePct": 0.04033424794213025,
          "price": 417.07,
          "tsLocal": "2026-02-12T16:00",
          "tsUtcMs": 1770930000000,
          "tzOffsetSec": -18000,
          "volume": 3891391
        }
      ],
      "reference": {
        "price": 400.9,
        "tsUtcMs": 1770388200000
      },
      "summary": {
        "latest": {
          "changeAbs": 16.170000000000016,
          "changePct": 0.04033424794213025,
          "price": 417.07,
          "tsLocal": "2026-02-12T16:00",
          "tsUtcMs": 1770930000000,
          "tzOffsetSec": -18000,
          "volume": 3891391
        },
        "maxChangePct": 0.07581691194811684,
        "minChangePct": 0.0
      }
    },
    {
      "currency": "USD",
      "exchange": "NASDAQ",
      "id": "NVDA",
      "intervalSec": 1800,
      "name": "NVIDIA Corp",
      "points": [
        {
          "changeAbs": 0.0,
          "changePct": 0.0,
          "price": 176.53,
          "tsLocal": "2026-02-06T09:30",
          "tsUtcMs": 1770388200000,
          "tzOffsetSec": -18000,
          "volume": 1730357
        },
        {
          "changeAbs": 4.039999999999992,
          "changePct": 0.022885628505069915,
          "price": 180.57,
          "tsLocal": "2026-02-06T10:00",
          "tsUtcMs": 1770390000000,
          "tzOffsetSec": -18000,
          "volume": 27320589
        },
        {
          "changeAbs": 6.060000000000002,
          "changePct": 0.03432844275760495,
          "price": 182.59,
          "tsLocal": "2026-02-06T10:30",
          "tsUtcMs": 1770391800000,
          "tzOffsetSec": -18000,
          "volume": 17487804
        },
        {
          "changeAbs": 6.275000000000006,
          "changePct": 0.035546366056760925,
          "price": 182.805,
          "tsLocal": "2026-02-06T11:00",
          "tsUtcMs": 1770393600000,
          "tzOffsetSec": -18000,
          "volume": 13597061
        },
        {
          "changeAbs": 7.444999999999993,
          "changePct": 0.042174134707981606,
          "price": 183.975,
          "tsLocal": "2026-02-06T11:30",
          "tsUtcMs": 1770395400000,
          "tzOffsetSec": -18000,
          "volume": 13330323
        },
        {
          "changeAbs": 6.761500000000012,
          "changePct": 0.03830227156857198,
          "price": 183.2915,
          "tsLocal": "2026-02-06T12:00",
          "tsUtcMs": 1770397200000,
          "tzOffsetSec": -18000,
          "volume": 10809768
        },
        {
          "changeAbs": 8.050000000000011,
          "changePct": 0.045601314224211244,
          "price": 184.58,
          "tsLocal": "2026-02-06T12:30",
          "tsUtcMs": 1770399000000,
          "tzOffsetSec": -18000,
          "volume": 7617619
        },
        {
          "changeAbs": 7.97999999999999,
          "changePct": 0.04520478105704407,
          "price": 184.51,
          "tsLocal": "2026-02-06T13:00",
          "tsUtcMs": 1770400800000,
          "tzOffsetSec": -18000,
          "volume": 9989733
        },
        {
          "changeAbs": 8.0,
          "changePct": 0.045318076247663285,
          "price": 184.53,
          "tsLocal": "2026-02-06T13:30",
          "tsUtcMs": 1770402600000,
          "tzOffsetSec": -18000,
          "volume": 5911814
        },
        {
          "changeAbs": 8.030100000000004,
          "changePct": 0.04548858550954515,
          "price": 184.5601,
          "tsLocal": "2026-02-06T14:00",
          "tsUtcMs": 1770404400000,
          "tzOffsetSec": -18000,
          "volume": 5444052
        },
        {
          "changeAbs": 7.9199999999999875,
          "changePct": 0.04486489548518658,
          "price": 184.45,
          "tsLocal": "2026-02-06T14:30",
          "tsUtcMs": 1770406200000,
          "tzOffsetSec": -18000,
          "volume": 5536407
        },
        {
          "changeAbs": 8.289999999999992,
          "changePct": 0.04696085651164104,
          "price": 184.82,
          "tsLocal": "2026-02-06T15:00",
          "tsUtcMs": 1770408000000,
          "tzOffsetSec": -18000,
          "volume": 6661977
        },
        {
          "changeAbs": 8.759999999999991,
          "changePct": 0.049623293491191246,
          "price": 185.29,
          "tsLocal": "2026-02-06T15:30",
          "tsUtcMs": 1770409800000,
          "tzOffsetSec": -18000,
          "volume": 10176310
        },
        {
          "changeAbs": 8.715000000000003,
          "changePct": 0.04936837931229821,
          "price": 185.245,
          "tsLocal": "2026-02-06T16:00",
          "tsUtcMs": 1770411600000,
          "tzOffsetSec": -18000,
          "volume": 26061682
        },
        {
          "changeAbs": 7.710000000000008,
          "changePct": 0.04367529598368554,
          "price": 184.24,
          "tsLocal": "2026-02-09T09:30",
          "tsUtcMs": 1770647400000,
          "tzOffsetSec": -18000,
          "volume": 1166802
        },
        {
          "changeAbs": 14.560000000000002,
          "changePct": 0.0824788987707472,
          "price": 191.09,
          "tsLocal": "2026-02-09T10:00",
          "tsUtcMs": 1770649200000,
          "tzOffsetSec": -18000,
          "volume": 36376045
        },
        {
          "changeAbs": 14.185000000000002,
          "changePct": 0.08035461394663798,
          "price": 190.715,
          "tsLocal": "2026-02-09T10:30",
          "tsUtcMs": 1770651000000,
          "tzOffsetSec": -18000,
          "volume": 15479375
        },
        {
          "changeAbs": 15.405000000000001,
          "changePct": 0.08726562057440662,
          "price": 191.935,
          "tsLocal": "2026-02-09T11:00",
          "tsUtcMs": 1770652800000,
          "tzOffsetSec": -18000,
          "volume": 10362019
        },
        {
          "changeAbs": 15.27000000000001,
          "changePct": 0.08650087803772735,
          "price": 191.8,
          "tsLocal": "2026-02-09T11:30",
          "tsUtcMs": 1770654600000,
          "tzOffsetSec": -18000,
          "volume": 7369736
        },
        {
          "changeAbs": 14.935000000000002,
          "changePct": 0.08460318359485641,
          "price": 191.465,
          "tsLocal": "2026-02-09T12:00",
          "tsUtcMs": 1770656400000,
          "tzOffsetSec": -18000,
          "volume": 5985328
        },
        {
          "changeAbs": 15.090000000000003,
          "changePct": 0.0854812213221549,
          "price": 191.62,
          "tsLocal": "2026-02-09T12:30",
          "tsUtcMs": 1770658200000,
          "tzOffsetSec": -18000,
          "volume": 8781434
        },
        {
          "changeAbs": 14.849999999999994,
          "changePct": 0.08412167903472495,
          "price": 191.38,
          "tsLocal": "2026-02-09T13:00",
          "tsUtcMs": 1770660000000,
          "tzOffsetSec": -18000,
          "volume": 4964754
        },
        {
          "changeAbs": 14.484999999999985,
          "changePct": 0.08205404180592525,
          "price": 191.015,
          "tsLocal": "2026-02-09T13:30",
          "tsUtcMs": 1770661800000,
          "tzOffsetSec": -18000,
          "volume": 4905672
        },
        {
          "changeAbs": 14.215000000000003,
          "changePct": 0.08052455673256673,
          "price": 190.745,
          "tsLocal": "2026-02-09T14:00",
          "tsUtcMs": 1770663600000,
          "tzOffsetSec": -18000,
          "volume": 4761749
        },
        {
          "changeAbs": 14.484999999999985,
          "changePct": 0.08205404180592525,
          "price": 191.015,
          "tsLocal": "2026-02-09T14:30",
          "tsUtcMs": 1770665400000,
          "tzOffsetSec": -18000,
          "volume": 5158368
        },
        {
          "changeAbs": 14.344999999999999,
          "changePct": 0.08126097547159122,
          "price": 190.875,
          "tsLocal": "2026-02-09T15:00",
          "tsUtcMs": 1770667200000,
          "tzOffsetSec": -18000,
          "volume": 5265632
        },
        {
          "changeAbs": 13.284999999999997,
          "changePct": 0.07525633036877583,
          "price": 189.815,
          "tsLocal": "2026-02-09T15:30",
          "tsUtcMs": 1770669000000,
          "tzOffsetSec": -18000,
          "volume": 8481482
        },
        {
          "changeAbs": 13.328000000000003,
          "changePct": 0.07549991502860705,
          "price": 189.858,
          "tsLocal": "2026-02-09T16:00",
          "tsUtcMs": 1770670800000,
          "tzOffsetSec": -18000,
          "volume": 16468574
        },
        {
          "changeAbs": 14.889999999999986,
          "changePct": 0.08434826941596321,
          "price": 191.42,
          "tsLocal": "2026-02-10T09:30",
          "tsUtcMs": 1770733800000,
          "tzOffsetSec": -18000,
          "volume": 1287601
        },
        {
          "changeAbs": 12.669999999999987,
          "changePct": 0.07177250325723666,
          "price": 189.2,
          "tsLocal": "2026-02-10T10:00",
          "tsUtcMs": 1770735600000,
          "tzOffsetSec": -18000,
          "volume": 18105554
        },
        {
          "changeAbs": 12.629999999999995,
          "changePct": 0.07154591287599839,
          "price": 189.16,
          "tsLocal": "2026-02-10T10:30",
          "tsUtcMs": 1770737400000,
          "tzOffsetSec": -18000,
          "volume": 10544183
        },
        {
          "changeAbs": 13.52539999999999,
          "changePct": 0.07661813856001808,
          "price": 190.0554,
          "tsLocal": "2026-02-10T11:00",
          "tsUtcMs": 1770739200000,
          "tzOffsetSec": -18000,
          "volume": 8185925
        },
        {
          "changeAbs": 12.490000000000009,
          "changePct": 0.07075284654166436,
          "price": 189.02,
          "tsLocal": "2026-02-10T11:30",
          "tsUtcMs": 1770741000000,
          "tzOffsetSec": -18000,
          "volume": 6198026
        },
        {
          "changeAbs": 12.759999999999991,
          "changePct": 0.07228233161502289,
          "price": 189.29,
          "tsLocal": "2026-02-10T12:00",
          "tsUtcMs": 1770742800000,
          "tzOffsetSec": -18000,
          "volume": 4937478
        },
        {
          "changeAbs": 13.164999999999992,
          "changePct": 0.07457655922506085,
          "price": 189.695,
          "tsLocal": "2026-02-10T12:30",
          "tsUtcMs": 1770744600000,
          "tzOffsetSec": -18000,
          "volume": 4580360
        },
        {
          "changeAbs": 13.719999999999999,
          "changePct": 0.07772050076474253,
          "price": 190.25,
          "tsLocal": "2026-02-10T13:00",
          "tsUtcMs": 1770746400000,
          "tzOffsetSec": -18000,
          "volume": 5186997
        },
        {
          "changeAbs": 12.699999999999989,
          "changePct": 0.07194244604316541,
          "price": 189.23,
          "tsLocal": "2026-02-10T13:30",
          "tsUtcMs": 1770748200000,
          "tzOffsetSec": -18000,
          "volume": 4017909
        },
        {
          "changeAbs": 12.949999999999989,
          "changePct": 0.07335863592590489,
          "price": 189.48,
          "tsLocal": "2026-02-10T14:00",
          "tsUtcMs": 1770750000000,
          "tzOffsetSec": -18000,
          "volume": 3502912
        },
        {
          "changeAbs": 12.699999999999989,
          "changePct": 0.07194244604316541,
          "price": 189.23,
          "tsLocal": "2026-02-10T14:30",
          "tsUtcMs": 1770751800000,
          "tzOffsetSec": -18000,
          "volume": 2769789
        },
        {
          "changeAbs": 12.4375,
          "changePct": 0.07045544666628901,
          "price": 188.9675,
          "tsLocal": "2026-02-10T15:00",
          "tsUtcMs": 1770753600000,
          "tzOffsetSec": -18000,
          "volume": 4337673
        },
        {
          "changeAbs": 12.560000000000002,
          "changePct": 0.07114937970883137,
          "price": 189.09,
          "tsLocal": "2026-02-10T15:30",
          "tsUtcMs": 1770755400000,
          "tzOffsetSec": -18000,
          "volume": 5807937
        },
        {
          "changeAbs": 12.067000000000007,
          "changePct": 0.06835665326006915,
          "price": 188.597,
          "tsLocal": "2026-02-10T16:00",
          "tsUtcMs": 1770757200000,
          "tzOffsetSec": -18000,
          "volume": 17050459
        },
        {
          "changeAbs": 15.759999999999991,
          "changePct": 0.08927661020789662,
          "price": 192.29,
          "tsLocal": "2026-02-11T09:30",
          "tsUtcMs": 1770820200000,
          "tzOffsetSec": -18000,
          "volume": 1295637
        },
        {
          "changeAbs": 14.669999999999987,
          "changePct": 0.08310202231915248,
          "price": 191.2,
          "tsLocal": "2026-02-11T10:00",
          "tsUtcMs": 1770822000000,
          "tzOffsetSec": -18000,
          "volume": 17976899
        },
        {
          "changeAbs": 12.460000000000008,
          "changePct": 0.07058290375573562,
          "price": 188.99,
          "tsLocal": "2026-02-11T10:30",
          "tsUtcMs": 1770823800000,
          "tzOffsetSec": -18000,
          "volume": 12861176
        },
        {
          "changeAbs": 15.074399999999997,
          "changePct": 0.08539285107347191,
          "price": 191.6044,
          "tsLocal": "2026-02-11T11:00",
          "tsUtcMs": 1770825600000,
          "tzOffsetSec": -18000,
          "volume": 10378894
        },
        {
          "changeAbs": 14.730099999999993,
          "changePct": 0.08344247436696309,
          "price": 191.2601,
          "tsLocal": "2026-02-11T11:30",
          "tsUtcMs": 1770827400000,
          "tzOffsetSec": -18000,
          "volume": 8260989
        },
        {
          "changeAbs": 14.310000000000002,
          "changePct": 0.08106270888800772,
          "price": 190.84,
          "tsLocal": "2026-02-11T12:00",
          "tsUtcMs": 1770829200000,
          "tzOffsetSec": -18000,
          "volume": 5554983
        },
        {
          "changeAbs": 15.430000000000007,
          "changePct": 0.08740723956268061,
          "price": 191.96,
          "tsLocal": "2026-02-11T12:30",
          "tsUtcMs": 1770831000000,
          "tzOffsetSec": -18000,
          "volume": 6287583
        },
        {
          "changeAbs": 15.27000000000001,
          "changePct": 0.08650087803772735,
          "price": 191.8,
          "tsLocal": "2026-02-11T13:00",
          "tsUtcMs": 1770832800000,
          "tzOffsetSec": -18000,
          "volume": 5110178
        },
        {
          "changeAbs": 14.9101,
          "changePct": 0.08446213108253554,
          "price": 191.4401,
          "tsLocal": "2026-02-11T13:30",
          "tsUtcMs": 1770834600000,
          "tzOffsetSec": -18000,
          "volume": 4245575
        },
        {
          "changeAbs": 15.245000000000005,
          "changePct": 0.08635925904945338,
          "price": 191.775,
          "tsLocal": "2026-02-11T14:00",
          "tsUtcMs": 1770836400000,
          "tzOffsetSec": -18000,
          "volume": 3895225
        },
        {
          "changeAbs": 15.51339999999999,
          "changePct": 0.0878796805075624,
          "price": 192.0434,
          "tsLocal": "2026-02-11T14:30",
          "tsUtcMs": 1770838200000,
          "tzOffsetSec": -18000,
          "volume": 4235432
        },
        {
          "changeAbs": 14.969999999999999,
          "changePct": 0.08480145017843992,
          "price": 191.5,
          "tsLocal": "2026-02-11T15:00",
          "tsUtcMs": 1770840000000,
          "tzOffsetSec": -18000,
          "volume": 3817975
        },
        {
          "changeAbs": 14.47999999999999,
          "changePct": 0.08202571800827049,
          "price": 191.01,
          "tsLocal": "2026-02-11T15:30",
          "tsUtcMs": 1770841800000,
          "tzOffsetSec": -18000,
          "volume": 4421531
        },
        {
          "changeAbs": 13.506499999999988,
          "changePct": 0.07651107460488296,
          "price": 190.0365,
          "tsLocal": "2026-02-11T16:00",
          "tsUtcMs": 1770843600000,
          "tzOffsetSec": -18000,
          "volume": 11663138
        },
        {
          "changeAbs": 16.539999999999992,
          "changePct": 0.0936951226420438,
          "price": 193.07,
          "tsLocal": "2026-02-12T09:30",
          "tsUtcMs": 1770906600000,
          "tzOffsetSec": -18000,
          "volume": 35615
        },
        {
          "changeAbs": 14.879999999999995,
          "changePct": 0.08429162182065368,
          "price": 191.41,
          "tsLocal": "2026-02-12T10:00",
          "tsUtcMs": 1770908400000,
          "tzOffsetSec": -18000,
          "volume": 18786109
        },
        {
          "changeAbs": 15.159999999999997,
          "changePct": 0.0858777544893219,
          "price": 191.69,
          "tsLocal": "2026-02-12T10:30",
          "tsUtcMs": 1770910200000,
          "tzOffsetSec": -18000,
          "volume": 11054280
        },
        {
          "changeAbs": 12.740000000000009,
          "changePct": 0.07216903642440384,
          "price": 189.27,
          "tsLocal": "2026-02-12T11:00",
          "tsUtcMs": 1770912000000,
          "tzOffsetSec": -18000,
          "volume": 12267762
        },
        {
          "changeAbs": 10.77000000000001,
          "changePct": 0.06100946014841676,
          "price": 187.3,
          "tsLocal": "2026-02-12T11:30",
          "tsUtcMs": 1770913800000,
          "tzOffsetSec": -18000,
          "volume": 11660730
        },
        {
          "changeAbs": 12.659999999999997,
          "changePct": 0.07171585566192713,
          "price": 189.19,
          "tsLocal": "2026-02-12T12:00",
          "tsUtcMs": 1770915600000,
          "tzOffsetSec": -18000,
          "volume": 9851593
        },
        {
          "changeAbs": 13.000100000000003,
          "changePct": 0.07364244037840595,
          "price": 189.5301,
          "tsLocal": "2026-02-12T12:30",
          "tsUtcMs": 1770917400000,
          "tzOffsetSec": -18000,
          "volume": 6918936
        },
        {
          "changeAbs": 13.139999999999986,
          "changePct": 0.07443494023678687,
          "price": 189.67,
          "tsLocal": "2026-02-12T13:00",
          "tsUtcMs": 1770919200000,
          "tzOffsetSec": -18000,
          "volume": 7544536
        },
        {
          "changeAbs": 12.65549999999999,
          "changePct": 0.07169036424403778,
          "price": 189.1855,
          "tsLocal": "2026-02-12T13:30",
          "tsUtcMs": 1770921000000,
          "tzOffsetSec": -18000,
          "volume": 7773098
        },
        {
          "changeAbs": 13.290600000000012,
          "changePct": 0.07528805302214928,
          "price": 189.8206,
          "tsLocal": "2026-02-12T14:00",
          "tsUtcMs": 1770922800000,
          "tzOffsetSec": -18000,
          "volume": 5346192
        },
        {
          "changeAbs": 12.569999999999993,
          "changePct": 0.0712060273041409,
          "price": 189.1,
          "tsLocal": "2026-02-12T14:30",
          "tsUtcMs": 1770924600000,
          "tzOffsetSec": -18000,
          "volume": 5518569
        },
        {
          "changeAbs": 11.740000000000009,
          "changePct": 0.06650427689344593,
          "price": 188.27,
          "tsLocal": "2026-02-12T15:00",
          "tsUtcMs": 1770926400000,
          "tzOffsetSec": -18000,
          "volume": 5696221
        },
        {
          "changeAbs": 11.025000000000006,
          "changePct": 0.062453973828811,
          "price": 187.555,
          "tsLocal": "2026-02-12T15:30",
          "tsUtcMs": 1770928200000,
          "tzOffsetSec": -18000,
          "volume": 6704186
        },
        {
          "changeAbs": 10.409999999999997,
          "changePct": 0.05897014671727183,
          "price": 186.94,
          "tsLocal": "2026-02-12T16:00",
          "tsUtcMs": 1770930000000,
          "tzOffsetSec": -18000,
          "volume": 20261347
        }
      ],
      "reference": {
        "price": 176.53,
        "tsUtcMs": 1770388200000
      },
      "summary": {
        "latest": {
          "changeAbs": 10.409999999999997,
          "changePct": 0.05897014671727183,
          "price": 186.94,
          "tsLocal": "2026-02-12T16:00",
          "tsUtcMs": 1770930000000,
          "tzOffsetSec": -18000,
          "volume": 20261347
        },
        "maxChangePct": 0.0936951226420438,
        "minChangePct": 0.0
      }
    },
    {
      "currency": null,
      "exchange": "INDEXSP",
      "id": ".INX",
      "intervalSec": 1800,
      "name": "S&P 500",
      "points": [
        {
          "changeAbs": 0.0,
          "changePct": 0.0,
          "price": 6868.13,
          "tsLocal": "2026-02-06T10:00",
          "tsUtcMs": 1770390000000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 9.890000000000327,
          "changePct": 0.001439984391675802,
          "price": 6878.02,
          "tsLocal": "2026-02-06T10:30",
          "tsUtcMs": 1770391800000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 11.300000000000182,
          "changePct": 0.0016452804475163081,
          "price": 6879.43,
          "tsLocal": "2026-02-06T11:00",
          "tsUtcMs": 1770393600000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 25.029999999999745,
          "changePct": 0.0036443689912683285,
          "price": 6893.16,
          "tsLocal": "2026-02-06T11:30",
          "tsUtcMs": 1770395400000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 28.25,
          "changePct": 0.004113201118790704,
          "price": 6896.38,
          "tsLocal": "2026-02-06T12:00",
          "tsUtcMs": 1770397200000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 38.710000000000036,
          "changePct": 0.005636177533040294,
          "price": 6906.84,
          "tsLocal": "2026-02-06T12:30",
          "tsUtcMs": 1770399000000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 43.42000000000007,
          "changePct": 0.006321953719571422,
          "price": 6911.55,
          "tsLocal": "2026-02-06T13:00",
          "tsUtcMs": 1770400800000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 43.17000000000007,
          "changePct": 0.006285553709670619,
          "price": 6911.3,
          "tsLocal": "2026-02-06T13:30",
          "tsUtcMs": 1770402600000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 43.73999999999978,
          "changePct": 0.006368545732244407,
          "price": 6911.87,
          "tsLocal": "2026-02-06T14:00",
          "tsUtcMs": 1770404400000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 48.840000000000146,
          "changePct": 0.007111105934220835,
          "price": 6916.97,
          "tsLocal": "2026-02-06T14:30",
          "tsUtcMs": 1770406200000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 47.289999999999964,
          "changePct": 0.006885425872835832,
          "price": 6915.42,
          "tsLocal": "2026-02-06T15:00",
          "tsUtcMs": 1770408000000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 51.80999999999949,
          "changePct": 0.007543538051842276,
          "price": 6919.94,
          "tsLocal": "2026-02-06T15:30",
          "tsUtcMs": 1770409800000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 62.409999999999854,
          "changePct": 0.009086898471636363,
          "price": 6930.54,
          "tsLocal": "2026-02-06T16:00",
          "tsUtcMs": 1770411600000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 56.80999999999949,
          "changePct": 0.00827153824985833,
          "price": 6924.94,
          "tsLocal": "2026-02-09T10:00",
          "tsUtcMs": 1770649200000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 73.02999999999975,
          "changePct": 0.010633170892222446,
          "price": 6941.16,
          "tsLocal": "2026-02-09T10:30",
          "tsUtcMs": 1770651000000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 96.51000000000022,
          "changePct": 0.014051859822105902,
          "price": 6964.64,
          "tsLocal": "2026-02-09T11:00",
          "tsUtcMs": 1770652800000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 100.97999999999956,
          "changePct": 0.01470269199913216,
          "price": 6969.11,
          "tsLocal": "2026-02-09T11:30",
          "tsUtcMs": 1770654600000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 107.55000000000018,
          "changePct": 0.015659284259325345,
          "price": 6975.68,
          "tsLocal": "2026-02-09T12:00",
          "tsUtcMs": 1770656400000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 105.09999999999945,
          "changePct": 0.015302564162297373,
          "price": 6973.23,
          "tsLocal": "2026-02-09T12:30",
          "tsUtcMs": 1770658200000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 99.53999999999996,
          "changePct": 0.014493027942103595,
          "price": 6967.67,
          "tsLocal": "2026-02-09T13:00",
          "tsUtcMs": 1770660000000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 96.07999999999993,
          "changePct": 0.01398925180507648,
          "price": 6964.21,
          "tsLocal": "2026-02-09T13:30",
          "tsUtcMs": 1770661800000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 100.5,
          "changePct": 0.014632803980122682,
          "price": 6968.63,
          "tsLocal": "2026-02-09T14:00",
          "tsUtcMs": 1770663600000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 111.11999999999989,
          "changePct": 0.016179076400708765,
          "price": 6979.25,
          "tsLocal": "2026-02-09T14:30",
          "tsUtcMs": 1770665400000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 107.65999999999985,
          "changePct": 0.01567530026368165,
          "price": 6975.79,
          "tsLocal": "2026-02-09T15:00",
          "tsUtcMs": 1770667200000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 99.47999999999956,
          "changePct": 0.014484291939727344,
          "price": 6967.61,
          "tsLocal": "2026-02-09T15:30",
          "tsUtcMs": 1770669000000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 94.55999999999949,
          "changePct": 0.013767939744879536,
          "price": 6962.69,
          "tsLocal": "2026-02-09T16:00",
          "tsUtcMs": 1770670800000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 110.25,
          "changePct": 0.016052404366253988,
          "price": 6978.38,
          "tsLocal": "2026-02-10T10:00",
          "tsUtcMs": 1770735600000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 112.26999999999953,
          "changePct": 0.016346516446252405,
          "price": 6980.4,
          "tsLocal": "2026-02-10T10:30",
          "tsUtcMs": 1770737400000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 107.19999999999982,
          "changePct": 0.015608324245464168,
          "price": 6975.33,
          "tsLocal": "2026-02-10T11:00",
          "tsUtcMs": 1770739200000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 100.84999999999945,
          "changePct": 0.014683763993983726,
          "price": 6968.98,
          "tsLocal": "2026-02-10T11:30",
          "tsUtcMs": 1770741000000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 100.26999999999953,
          "changePct": 0.014599315971013875,
          "price": 6968.4,
          "tsLocal": "2026-02-10T12:00",
          "tsUtcMs": 1770742800000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 105.22999999999956,
          "changePct": 0.015321492167445806,
          "price": 6973.36,
          "tsLocal": "2026-02-10T12:30",
          "tsUtcMs": 1770744600000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 106.94999999999982,
          "changePct": 0.015571924235563365,
          "price": 6975.08,
          "tsLocal": "2026-02-10T13:00",
          "tsUtcMs": 1770746400000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 87.39999999999964,
          "changePct": 0.012725443461320568,
          "price": 6955.53,
          "tsLocal": "2026-02-10T13:30",
          "tsUtcMs": 1770748200000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 89.5,
          "changePct": 0.013031203544487363,
          "price": 6957.63,
          "tsLocal": "2026-02-10T14:00",
          "tsUtcMs": 1770750000000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 91.38000000000011,
          "changePct": 0.013304931618941416,
          "price": 6959.51,
          "tsLocal": "2026-02-10T14:30",
          "tsUtcMs": 1770751800000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 90.40999999999985,
          "changePct": 0.013163699580526265,
          "price": 6958.54,
          "tsLocal": "2026-02-10T15:00",
          "tsUtcMs": 1770753600000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 85.72000000000025,
          "changePct": 0.012480835394787265,
          "price": 6953.85,
          "tsLocal": "2026-02-10T15:30",
          "tsUtcMs": 1770755400000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 73.9399999999996,
          "changePct": 0.010765666928261346,
          "price": 6942.07,
          "tsLocal": "2026-02-10T16:00",
          "tsUtcMs": 1770757200000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 93.13000000000011,
          "changePct": 0.013559731688247034,
          "price": 6961.26,
          "tsLocal": "2026-02-11T10:00",
          "tsUtcMs": 1770822000000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 49.35999999999967,
          "changePct": 0.007186817954814436,
          "price": 6917.49,
          "tsLocal": "2026-02-11T10:30",
          "tsUtcMs": 1770823800000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 76.05999999999949,
          "changePct": 0.011074339012220137,
          "price": 6944.19,
          "tsLocal": "2026-02-11T11:00",
          "tsUtcMs": 1770825600000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 71.23999999999978,
          "changePct": 0.010372546821332703,
          "price": 6939.37,
          "tsLocal": "2026-02-11T11:30",
          "tsUtcMs": 1770827400000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 72.98999999999978,
          "changePct": 0.010627346890638323,
          "price": 6941.12,
          "tsLocal": "2026-02-11T12:00",
          "tsUtcMs": 1770829200000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 88.09999999999945,
          "changePct": 0.012827363489042789,
          "price": 6956.23,
          "tsLocal": "2026-02-11T12:30",
          "tsUtcMs": 1770831000000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 80.05999999999949,
          "changePct": 0.01165673917063298,
          "price": 6948.19,
          "tsLocal": "2026-02-11T13:00",
          "tsUtcMs": 1770832800000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 80.59999999999945,
          "changePct": 0.011735363192018709,
          "price": 6948.73,
          "tsLocal": "2026-02-11T13:30",
          "tsUtcMs": 1770834600000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 79.75,
          "changePct": 0.011611603158356059,
          "price": 6947.88,
          "tsLocal": "2026-02-11T14:00",
          "tsUtcMs": 1770836400000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 90.47000000000025,
          "changePct": 0.013172435582902516,
          "price": 6958.6,
          "tsLocal": "2026-02-11T14:30",
          "tsUtcMs": 1770838200000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 81.64999999999964,
          "changePct": 0.011888243233602106,
          "price": 6949.78,
          "tsLocal": "2026-02-11T15:00",
          "tsUtcMs": 1770840000000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 75.31999999999971,
          "changePct": 0.010966594982913793,
          "price": 6943.45,
          "tsLocal": "2026-02-11T15:30",
          "tsUtcMs": 1770841800000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 72.05999999999949,
          "changePct": 0.010491938853807293,
          "price": 6940.19,
          "tsLocal": "2026-02-11T16:00",
          "tsUtcMs": 1770843600000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 81.34000000000015,
          "changePct": 0.011843107221325186,
          "price": 6949.47,
          "tsLocal": "2026-02-12T10:00",
          "tsUtcMs": 1770908400000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 82.55000000000018,
          "changePct": 0.012019283269245076,
          "price": 6950.68,
          "tsLocal": "2026-02-12T10:30",
          "tsUtcMs": 1770910200000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 37.26999999999953,
          "changePct": 0.0054265134760115965,
          "price": 6905.4,
          "tsLocal": "2026-02-12T11:00",
          "tsUtcMs": 1770912000000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": -12.819999999999709,
          "changePct": -0.0018665925077131196,
          "price": 6855.31,
          "tsLocal": "2026-02-12T11:30",
          "tsUtcMs": 1770913800000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": -2.1099999999996726,
          "changePct": -0.00030721608356272707,
          "price": 6866.02,
          "tsLocal": "2026-02-12T12:00",
          "tsUtcMs": 1770915600000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": -7.449999999999818,
          "changePct": -0.0010847202950438938,
          "price": 6860.68,
          "tsLocal": "2026-02-12T12:30",
          "tsUtcMs": 1770917400000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": -18.520000000000437,
          "changePct": -0.002696512733451527,
          "price": 6849.61,
          "tsLocal": "2026-02-12T13:00",
          "tsUtcMs": 1770919200000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": -16.840000000000146,
          "changePct": -0.0024519046669180906,
          "price": 6851.29,
          "tsLocal": "2026-02-12T13:30",
          "tsUtcMs": 1770921000000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": -1.1700000000000728,
          "changePct": -0.0001703520463357672,
          "price": 6866.96,
          "tsLocal": "2026-02-12T14:00",
          "tsUtcMs": 1770922800000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": -6.850000000000364,
          "changePct": -0.0009973602712820468,
          "price": 6861.28,
          "tsLocal": "2026-02-12T14:30",
          "tsUtcMs": 1770924600000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": 2.9099999999998545,
          "changePct": 0.0004236961152453222,
          "price": 6871.04,
          "tsLocal": "2026-02-12T15:00",
          "tsUtcMs": 1770926400000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": -16.48999999999978,
          "changePct": -0.002400944653056914,
          "price": 6851.64,
          "tsLocal": "2026-02-12T15:30",
          "tsUtcMs": 1770928200000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        {
          "changeAbs": -35.48999999999978,
          "changePct": -0.005167345405517918,
          "price": 6832.64,
          "tsLocal": "2026-02-12T16:00",
          "tsUtcMs": 1770930000000,
          "tzOffsetSec": -18000,
          "volume": null
        }
      ],
      "reference": {
        "price": 6868.13,
        "tsUtcMs": 1770390000000
      },
      "summary": {
        "latest": {
          "changeAbs": -35.48999999999978,
          "changePct": -0.005167345405517918,
          "price": 6832.64,
          "tsLocal": "2026-02-12T16:00",
          "tsUtcMs": 1770930000000,
          "tzOffsetSec": -18000,
          "volume": null
        },
        "maxChangePct": 0.016346516446252405,
        "minChangePct": -0.005167345405517918
      }
    }
  ],
  "tz": {
    "label": "UTC-5",
    "offsetSec": -18000
  },
  "yAxis": {
    "domain": [
      -0.1,
      0.1
    ],
    "ticks": [
      -0.1,
      -0.05,
      0.0,
      0.05,
      0.1
    ],
    "unit": "pct"
  }
};

export const heatmapData = {
  "chg": -2.0743378278589213,
  "children": [
    {
      "chg": -2.595603047819432,
      "children": [
        {
          "chg": -1.1747261037111199,
          "children": [
            {
              "chg": -0.626,
              "description": "Microsoft Corporation",
              "name": "MSFT",
              "value": 3300793
            },
            {
              "chg": -4.828,
              "description": "Palantir Technologies Inc",
              "name": "PLTR",
              "value": 394054
            },
            {
              "chg": -1.506,
              "description": "Palo Alto Networks Inc",
              "name": "PANW",
              "value": 126485
            },
            {
              "chg": -1.027,
              "description": "Crowdstrike Holdings Inc",
              "name": "CRWD",
              "value": 112406
            },
            {
              "chg": -3.391,
              "description": "Synopsys, Inc",
              "name": "SNPS",
              "value": 99859
            },
            {
              "chg": -4.054,
              "description": "Fortinet Inc",
              "name": "FTNT",
              "value": 56331
            },
            {
              "chg": -0.058,
              "description": "Zscaler Inc",
              "name": "ZS",
              "value": 33275
            }
          ],
          "name": "Software - Infrastructure",
          "value": 4123203
        },
        {
          "chg": -2.069753808090662,
          "children": [
            {
              "chg": -1.636,
              "description": "NVIDIA Corp",
              "name": "NVDA",
              "value": 4454676
            },
            {
              "chg": -3.381,
              "description": "Broadcom Inc",
              "name": "AVGO",
              "value": 1558931
            },
            {
              "chg": 0.885,
              "description": "Micron Technology Inc",
              "name": "MU",
              "value": 437947
            },
            {
              "chg": -3.577,
              "description": "Advanced Micro Devices Inc",
              "name": "AMD",
              "value": 406685
            },
            {
              "chg": -3.748,
              "description": "Intel Corp",
              "name": "INTC",
              "value": 270424
            },
            {
              "chg": -1.571,
              "description": "Texas Instruments Inc",
              "name": "TXN",
              "value": 176645
            },
            {
              "chg": -1.822,
              "description": "Qualcomm, Inc",
              "name": "QCOM",
              "value": 167472
            },
            {
              "chg": -1.674,
              "description": "Analog Devices Inc",
              "name": "ADI",
              "value": 149330
            },
            {
              "chg": -2.466,
              "description": "Arm Holdings plc. ADR",
              "name": "ARM",
              "value": 120869
            },
            {
              "chg": -3.823,
              "description": "Marvell Technology Inc",
              "name": "MRVL",
              "value": 70011
            },
            {
              "chg": -3.027,
              "description": "NXP Semiconductors NV",
              "name": "NXPI",
              "value": 58821
            },
            {
              "chg": -3.409,
              "description": "Monolithic Power System Inc",
              "name": "MPWR",
              "value": 51497
            },
            {
              "chg": -2.266,
              "description": "Microchip Technology, Inc",
              "name": "MCHP",
              "value": 41182
            }
          ],
          "name": "Semiconductors",
          "value": 7964490
        },
        {
          "chg": -4.998,
          "children": [
            {
              "chg": -4.998,
              "description": "Apple Inc",
              "name": "AAPL",
              "value": 3639941
            }
          ],
          "name": "Consumer Electronics",
          "value": 3639941
        },
        {
          "chg": -2.1875741898904493,
          "children": [
            {
              "chg": -2.003,
              "description": "ASML Holding NV",
              "name": "ASML",
              "value": 527171
            },
            {
              "chg": -1.629,
              "description": "Lam Research Corp",
              "name": "LRCX",
              "value": 286865
            },
            {
              "chg": -3.381,
              "description": "Applied Materials Inc",
              "name": "AMAT",
              "value": 257897
            },
            {
              "chg": -1.936,
              "description": "KLA Corp",
              "name": "KLAC",
              "value": 199716
            }
          ],
          "name": "Semiconductor Equipment & Materials",
          "value": 1271649
        },
        {
          "chg": -2.5469894629014043,
          "children": [
            {
              "chg": -6.781,
              "description": "Shopify Inc",
              "name": "SHOP",
              "value": 180357
            },
            {
              "chg": -0.433,
              "description": "Intuit Inc",
              "name": "INTU",
              "value": 146072
            },
            {
              "chg": 2.077,
              "description": "Adobe Inc",
              "name": "ADBE",
              "value": 120781
            },
            {
              "chg": -3.498,
              "description": "Automatic Data Processing Inc",
              "name": "ADP",
              "value": 103939
            },
            {
              "chg": -3.778,
              "description": "Cadence Design Systems, Inc",
              "name": "CDNS",
              "value": 85428
            },
            {
              "chg": -3.912,
              "description": "Autodesk Inc",
              "name": "ADSK",
              "value": 54577
            },
            {
              "chg": -0.353,
              "description": "Workday Inc",
              "name": "WDAY",
              "value": 48237
            },
            {
              "chg": -2.435,
              "description": "Strategy Inc",
              "name": "MSTR",
              "value": 47071
            },
            {
              "chg": -4.188,
              "description": "Roper Technologies Inc",
              "name": "ROP",
              "value": 43557
            },
            {
              "chg": -0.942,
              "description": "Datadog Inc",
              "name": "DDOG",
              "value": 43294
            },
            {
              "chg": -2.499,
              "description": "Paychex Inc",
              "name": "PAYX",
              "value": 38478
            },
            {
              "chg": -0.563,
              "description": "Atlassian Corporation",
              "name": "TEAM",
              "value": 32207
            }
          ],
          "name": "Software - Application",
          "value": 943998
        },
        {
          "chg": -12.322,
          "children": [
            {
              "chg": -12.322,
              "description": "Cisco Systems, Inc",
              "name": "CSCO",
              "value": 291156
            }
          ],
          "name": "Communication Equipment",
          "value": 291156
        },
        {
          "chg": 4.768026572182107,
          "children": [
            {
              "chg": 3.785,
              "description": "Western Digital Corp",
              "name": "WDC",
              "value": 82705
            },
            {
              "chg": 5.874,
              "description": "Seagate Technology Holdings Plc",
              "name": "STX",
              "value": 73511
            }
          ],
          "name": "Computer Hardware",
          "value": 156216
        },
        {
          "chg": -7.164,
          "children": [
            {
              "chg": -7.164,
              "description": "Cognizant Technology Solutions Corp",
              "name": "CTSH",
              "value": 40557
            }
          ],
          "name": "Information Technology Services",
          "value": 40557
        }
      ],
      "name": "Technology",
      "value": 18431210
    },
    {
      "chg": -2.396214719140996,
      "children": [
        {
          "chg": -2.426035692211235,
          "children": [
            {
              "chg": -2.195,
              "description": "Amazon.com Inc",
              "name": "AMZN",
              "value": 2472754
            },
            {
              "chg": -4.16,
              "description": "PDD Holdings Inc ADR",
              "name": "PDD",
              "value": 147457
            },
            {
              "chg": -0.554,
              "description": "MercadoLibre Inc",
              "name": "MELI",
              "value": 104323
            },
            {
              "chg": -8.167,
              "description": "DoorDash Inc",
              "name": "DASH",
              "value": 88993
            }
          ],
          "name": "Internet Retail",
          "value": 2813527
        },
        {
          "chg": -2.615,
          "children": [
            {
              "chg": -2.615,
              "description": "Tesla Inc",
              "name": "TSLA",
              "value": 1434892
            }
          ],
          "name": "Auto Manufacturers",
          "value": 1434892
        },
        {
          "chg": -3.3731351126374287,
          "children": [
            {
              "chg": -3.556,
              "description": "Booking Holdings Inc",
              "name": "BKNG",
              "value": 166443
            },
            {
              "chg": -3.003,
              "description": "Airbnb Inc",
              "name": "ABNB",
              "value": 82231
            }
          ],
          "name": "Travel Services",
          "value": 248674
        },
        {
          "chg": -2.381,
          "children": [
            {
              "chg": -2.381,
              "description": "Starbucks Corp",
              "name": "SBUX",
              "value": 109651
            }
          ],
          "name": "Restaurants",
          "value": 109651
        },
        {
          "chg": -1.023,
          "children": [
            {
              "chg": -1.023,
              "description": "Marriott International, Inc",
              "name": "MAR",
              "value": 86023
            }
          ],
          "name": "Lodging",
          "value": 86023
        },
        {
          "chg": 1.169,
          "children": [
            {
              "chg": 1.169,
              "description": "O'Reilly Automotive, Inc",
              "name": "ORLY",
              "value": 83381
            }
          ],
          "name": "Auto Parts",
          "value": 83381
        },
        {
          "chg": 1.2,
          "children": [
            {
              "chg": 1.2,
              "description": "Ross Stores, Inc",
              "name": "ROST",
              "value": 62205
            }
          ],
          "name": "Apparel Retail",
          "value": 62205
        }
      ],
      "name": "Consumer Cyclical",
      "value": 4838353
    },
    {
      "chg": 2.364083573675895,
      "children": [
        {
          "chg": 3.258831387019127,
          "children": [
            {
              "chg": 3.782,
              "description": "Walmart Inc",
              "name": "WMT",
              "value": 951319
            },
            {
              "chg": 2.118,
              "description": "Costco Wholesale Corp",
              "name": "COST",
              "value": 436261
            }
          ],
          "name": "Discount Stores",
          "value": 1387580
        },
        {
          "chg": -0.3708838641420106,
          "children": [
            {
              "chg": -1.153,
              "description": "PepsiCo Inc",
              "name": "PEP",
              "value": 200643
            },
            {
              "chg": 0.47,
              "description": "Monster Beverage Corp",
              "name": "MNST",
              "value": 79725
            },
            {
              "chg": 1.454,
              "description": "Coca-Cola Europacific Partners Plc",
              "name": "CCEP",
              "value": 40226
            },
            {
              "chg": 0.067,
              "description": "Keurig Dr Pepper Inc",
              "name": "KDP",
              "value": 37633
            }
          ],
          "name": "Beverages - Non-Alcoholic",
          "value": 358227
        },
        {
          "chg": 0.634,
          "children": [
            {
              "chg": 0.634,
              "description": "Mondelez International Inc",
              "name": "MDLZ",
              "value": 74002
            }
          ],
          "name": "Confectioners",
          "value": 74002
        },
        {
          "chg": -2.681,
          "children": [
            {
              "chg": -2.681,
              "description": "Kraft Heinz Co",
              "name": "KHC",
              "value": 26514
            }
          ],
          "name": "Packaged Foods",
          "value": 26514
        }
      ],
      "name": "Consumer Defensive",
      "value": 1846323
    },
    {
      "chg": -1.8680100947392433,
      "children": [
        {
          "chg": -1.245304378785782,
          "children": [
            {
              "chg": -0.63,
              "description": "Alphabet Inc",
              "name": "GOOG",
              "value": 3961475
            },
            {
              "chg": -2.823,
              "description": "Meta Platforms Inc",
              "name": "META",
              "value": 1544983
            }
          ],
          "name": "Internet Content & Information",
          "value": 5506458
        },
        {
          "chg": -3.931520643023173,
          "children": [
            {
              "chg": -4.722,
              "description": "Netflix Inc",
              "name": "NFLX",
              "value": 390052
            },
            {
              "chg": 0.429,
              "description": "Warner Bros. Discovery Inc",
              "name": "WBD",
              "value": 70709
            }
          ],
          "name": "Entertainment",
          "value": 460761
        },
        {
          "chg": 0.7583648329395881,
          "children": [
            {
              "chg": 2.453,
              "description": "T-Mobile US Inc",
              "name": "TMUS",
              "value": 205358
            },
            {
              "chg": -2.032,
              "description": "Comcast Corp",
              "name": "CMCSA",
              "value": 105272
            },
            {
              "chg": -1.24,
              "description": "Charter Communications Inc",
              "name": "CHTR",
              "value": 27152
            }
          ],
          "name": "Telecom Services",
          "value": 337782
        },
        {
          "chg": -19.68,
          "children": [
            {
              "chg": -19.68,
              "description": "Applovin Corp",
              "name": "APP",
              "value": 179981
            }
          ],
          "name": "Advertising Agencies",
          "value": 179981
        },
        {
          "chg": -3.544932529791016,
          "children": [
            {
              "chg": -0.88,
              "description": "Electronic Arts, Inc",
              "name": "EA",
              "value": 51059
            },
            {
              "chg": -6.636,
              "description": "Take-Two Interactive Software, Inc",
              "name": "TTWO",
              "value": 44020
            }
          ],
          "name": "Electronic Gaming & Multimedia",
          "value": 95079
        }
      ],
      "name": "Communication Services",
      "value": 6580061
    },
    {
      "chg": -2.115751492473892,
      "children": [
        {
          "chg": -1.2441079007896734,
          "children": [
            {
              "chg": -0.104,
              "description": "AMGEN Inc",
              "name": "AMGN",
              "value": 185022
            },
            {
              "chg": -2.561,
              "description": "Gilead Sciences, Inc",
              "name": "GILD",
              "value": 160184
            }
          ],
          "name": "Drug Manufacturers - General",
          "value": 345206
        },
        {
          "chg": -1.3106011971940763,
          "children": [
            {
              "chg": 0.82,
              "description": "Vertex Pharmaceuticals, Inc",
              "name": "VRTX",
              "value": 117000.0
            },
            {
              "chg": 0.601,
              "description": "Regeneron Pharmaceuticals, Inc",
              "name": "REGN",
              "value": 78754
            },
            {
              "chg": -4.282,
              "description": "Alnylam Pharmaceuticals Inc",
              "name": "ALNY",
              "value": 48282
            },
            {
              "chg": -1.523,
              "description": "Insmed Inc",
              "name": "INSM",
              "value": 33339
            }
          ],
          "name": "Biotechnology",
          "value": 160375
        },
        {
          "chg": -3.5310000000000006,
          "children": [
            {
              "chg": -3.531,
              "description": "Intuitive Surgical Inc",
              "name": "ISRG",
              "value": 185646
            }
          ],
          "name": "Medical Instruments & Supplies",
          "value": 185646
        },
        {
          "chg": -2.3412338358922344,
          "children": [
            {
              "chg": -0.694,
              "description": "GE HealthCare Technologies Inc",
              "name": "GEHC",
              "value": 36943
            },
            {
              "chg": -4.505,
              "description": "Dexcom Inc",
              "name": "DXCM",
              "value": 28124
            }
          ],
          "name": "Medical Devices",
          "value": 65067
        },
        {
          "chg": -4.859999999999999,
          "children": [
            {
              "chg": -4.86,
              "description": "Idexx Laboratories, Inc",
              "name": "IDXX",
              "value": 55613
            }
          ],
          "name": "Diagnostics & Research",
          "value": 55613
        }
      ],
      "name": "Healthcare",
      "value": 811907
    },
    {
      "chg": -2.2141992398485772,
      "children": [
        {
          "chg": -3.7699182856243545,
          "children": [
            {
              "chg": -2.126,
              "description": "Cintas Corporation",
              "name": "CTAS",
              "value": 78142
            },
            {
              "chg": -3.711,
              "description": "Thomson-Reuters Corp",
              "name": "TRI",
              "value": 53430
            },
            {
              "chg": -7.061,
              "description": "Copart, Inc",
              "name": "CPRT",
              "value": 39989
            }
          ],
          "name": "Specialty Business Services",
          "value": 171561
        },
        {
          "chg": -1.183,
          "children": [
            {
              "chg": -1.183,
              "description": "Honeywell International Inc",
              "name": "HON",
              "value": 139148
            }
          ],
          "name": "Conglomerates",
          "value": 139148
        },
        {
          "chg": -1.548,
          "children": [
            {
              "chg": -1.548,
              "description": "CSX Corp",
              "name": "CSX",
              "value": 68024
            }
          ],
          "name": "Railroads",
          "value": 68024
        },
        {
          "chg": -3.584,
          "children": [
            {
              "chg": -3.584,
              "description": "Paccar Inc",
              "name": "PCAR",
              "value": 64737
            }
          ],
          "name": "Farm & Heavy Construction Machinery",
          "value": 64737
        },
        {
          "chg": -3.1480000000000006,
          "children": [
            {
              "chg": -3.148,
              "description": "Fastenal Co",
              "name": "FAST",
              "value": 51214
            }
          ],
          "name": "Industrial Distribution",
          "value": 51214
        },
        {
          "chg": -1.7110000000000003,
          "children": [
            {
              "chg": -1.711,
              "description": "Ferrovial S.E",
              "name": "FER",
              "value": 48224
            }
          ],
          "name": "Engineering & Construction",
          "value": 48224
        },
        {
          "chg": 0.313,
          "children": [
            {
              "chg": 0.313,
              "description": "Axon Enterprise Inc",
              "name": "AXON",
              "value": 48155
            }
          ],
          "name": "Aerospace & Defense",
          "value": 48155
        },
        {
          "chg": -4.602,
          "children": [
            {
              "chg": -4.602,
              "description": "Old Dominion Freight Line, Inc",
              "name": "ODFL",
              "value": 37303
            }
          ],
          "name": "Trucking",
          "value": 37303
        },
        {
          "chg": 3.01,
          "children": [
            {
              "chg": 3.01,
              "description": "Verisk Analytics Inc",
              "name": "VRSK",
              "value": 30187
            }
          ],
          "name": "Consulting Services",
          "value": 30187
        }
      ],
      "name": "Industrials",
      "value": 658553
    },
    {
      "chg": 1.144,
      "children": [
        {
          "chg": 1.144,
          "children": [
            {
              "chg": 1.144,
              "description": "Linde Plc",
              "name": "LIN",
              "value": 205154
            }
          ],
          "name": "Specialty Chemicals",
          "value": 205154
        }
      ],
      "name": "Basic Materials",
      "value": 205154
    },
    {
      "chg": -5.933,
      "children": [
        {
          "chg": -5.933,
          "children": [
            {
              "chg": -5.933,
              "description": "Costar Group, Inc",
              "name": "CSGP",
              "value": 27451
            }
          ],
          "name": "Real Estate Services",
          "value": 27451
        }
      ],
      "name": "Real Estate",
      "value": 27451
    },
    {
      "chg": -3.411,
      "children": [
        {
          "chg": -3.411,
          "children": [
            {
              "chg": -3.411,
              "description": "PayPal Holdings Inc",
              "name": "PYPL",
              "value": 52294
            }
          ],
          "name": "Credit Services",
          "value": 52294
        }
      ],
      "name": "Financial",
      "value": 52294
    },
    {
      "chg": -0.30130386997384173,
      "children": [
        {
          "chg": 0.229,
          "children": [
            {
              "chg": 0.229,
              "description": "Baker Hughes Co",
              "name": "BKR",
              "value": 52881
            }
          ],
          "name": "Oil & Gas Equipment & Services",
          "value": 52881
        },
        {
          "chg": -0.941,
          "children": [
            {
              "chg": -0.941,
              "description": "Diamondback Energy Inc",
              "name": "FANG",
              "value": 43838
            }
          ],
          "name": "Oil & Gas E&P",
          "value": 43838
        }
      ],
      "name": "Energy",
      "value": 96719
    },
    {
      "chg": 2.321745664059009,
      "children": [
        {
          "chg": 3.862593230007325,
          "children": [
            {
              "chg": 3.419,
              "description": "American Electric Power Company Inc",
              "name": "AEP",
              "value": 63547
            },
            {
              "chg": 6.974,
              "description": "Exelon Corp",
              "name": "EXC",
              "value": 45463
            },
            {
              "chg": 1.36,
              "description": "Xcel Energy, Inc",
              "name": "XEL",
              "value": 45259
            }
          ],
          "name": "Utilities - Regulated Electric",
          "value": 154269
        },
        {
          "chg": -0.264,
          "children": [
            {
              "chg": -0.264,
              "description": "Constellation Energy Corporation",
              "name": "CEG",
              "value": 91929
            }
          ],
          "name": "Utilities - Independent Power Producers",
          "value": 91929
        }
      ],
      "name": "Utilities",
      "value": 246198
    }
  ],
  "name": "Root",
  "value": 33794223
};

export const newsData = {
    sectorId: 'consumer-cyclical',
    label: 'Consumer Cyclical',
    count: 3,
    bullish: ['CROX', 'ANDG', 'STLA', 'BOBS', 'NSANY'],
    bearish: ['MLCO', 'QS', 'KMX', 'ROL', 'BGSI'],
    news: [
        {
            publish_time: Date.now() - 1000 * 60 * 60 * 2,
            title: "Stock market today: Dow, S&P 500, Nasdaq futures flat as AI fears return ahead of CPI inflation report",
            url: "https://finance.yahoo.com/news/live/stock-market-today-dow-sp-500-nasdaq-sink-as-tech-gets-hit-as-ai-disruption-fears-grow-gold-bitcoin-sink-210353533.html",
            summary: "Bloomberg: Markets remain cautious as inflation data looms. AI sector volatility continues to influence broader market sentiment."
        },
        {
            publish_time: Date.now() - 1000 * 60 * 60 * 5,
            title: "Rivian surges on delivery guidance, R2 on track for Q2 launch; CEO says 'key inflection' reached",
            url: "https://finance.yahoo.com/news/rivian-surges-over-20-on-delivery-guidance-r2-launch-in-q2-ceo-says-key-inflection-reached-143919862.html",
            summary: "CNBC: EV maker Rivian sees positive momentum with new model launch and improved delivery numbers."
        },
        {
            publish_time: Date.now() - 1000 * 60 * 60 * 12,
            title: "McDonald's is all in on its Extra Value Meals, global CFO says...",
            url: "https://finance.yahoo.com/video/mcdonalds-extra-value-meals-global-145858951.html",
            summary: "Yahoo Finance: Fast food giant doubles down on value strategy to combat slowing consumer spending."
        },
    ]
};

export const FINAL_RESPONSE_TEXT = `### Market Sentiment: Top Movers

The following stocks led the performance within the Consumer Cyclical sector today:

**Top Gainers:**
• CROX  (Crocs, Inc.)          +19.01%
• ANDG  (Andersons, Inc.)      +5.07%
• STLA  (Stellantis N.V.)      +3.67%
• BOBS  (Bob's Discount)       +3.63%
• NSANY (Nissan Motor Co.)     +3.61%

**Top Losers:**
• MLCO  (Melco Resorts)        -12.50%
• QS    (QuantumScape Corp.)   -11.96%
• KMX   (CarMax, Inc.)         -10.57%`;
